import ViewCutscene from '@/views/ViewCutscene.vue'
import ViewGame from '@/views/ViewGame.vue'
import ViewSplash from '@/views/ViewSplash.vue'

import ViewCredits from '@/views/cutscenes/ViewCredits.vue'
import ViewStoryIntro from '@/views/cutscenes/ViewStoryIntro.vue'

import ViewDecoder from '@/views/game/ViewDecoder.vue'
import ViewDebug from '@/views/game/ViewDebug.vue'
import ViewFiles from '@/views/game/ViewFiles.vue'
import ViewFile from '@/views/game/ViewFile.vue'
import ViewInventory from '@/views/game/ViewInventory.vue'
import ViewMap from '@/views/game/ViewMap.vue'
import ViewNotebook from '@/views/game/ViewNotebook.vue'
import ViewRadios from '@/views/game/ViewRadios.vue'
import ViewSettings from '@/views/game/ViewSettings.vue'

export default [

  {
    path: '/',
    name: 'splash',
    component: ViewSplash
  },

  {
    path: '/game',
    name: 'game',
    component: ViewGame,
    redirect: {
      name: 'radios'
    },
    children: [

      // Game
      {
        path: 'decoder',
        name: 'decoder',
        component: ViewDecoder
      },

      {
        path: 'files',
        name: 'files',
        component: ViewFiles
      },

      {
        path: 'files/:fileSlug',
        name: 'file',
        component: ViewFile,
        props: true
      },

      {
        path: 'inventory',
        name: 'inventory',
        component: ViewInventory
      },

      {
        path: 'map',
        name: 'map',
        component: ViewMap
      },

      {
        path: 'notebook',
        name: 'notebook',
        component: ViewNotebook
      },

      {
        path: 'radios',
        name: 'radios',
        component: ViewRadios
      },

      //
      {
        path: '/debug',
        name: 'debug',
        component: ViewDebug
      },

      {
        path: '/settings',
        name: 'settings',
        component: ViewSettings
      }

    ]
  },

  {
    path: '/cutscene',
    name: 'cutscene',
    component: ViewCutscene,
    redirect: {
      name: 'storyIntro'
    },
    children: [

      {
        path: 'credits',
        name: 'credits',
        component: ViewCredits
      },

      {
        path: 'storyIntro',
        name: 'storyIntro',
        component: ViewStoryIntro
      }

    ]
  }

]
